import styled from 'styled-components';
import { theme } from 'modules/tetrisTheme';
export const ListItemTextContainer = styled.div `
  display: flex;
  flex-direction: column;
  overflow: hidden;
  gap: ${theme.spacing.xs};
`;
